import React, {useEffect, useState} from "react";
import {EditButton} from "../../../helpers/ButtonHelper";
import {saveData} from "../../../helpers/Api";
import {Modal} from "react-bootstrap";
import {useMutation} from "@apollo/client";
import PlateIngredientForm from "./PlateIngredientForm";
import {getPlateIngredients, UpdatePlateIngredient} from "./PlateQueries";

const EditPlateIngredientModal = ({
                                    plateIngredientIds,
                                    plateIngredient,
                                    onClose,
                                    shouldOpen,
                                    showButton
                                  }) => {
  const [show, setShow] = useState(false);
  const [flash, setFlash] = useState({});
  const [gqlCall] = useMutation(UpdatePlateIngredient, {refetchQueries: [getPlateIngredients]})

  const closeModal = () => {
    setFlash({})
    setShow(false);
    if (onClose) onClose();
    // resetForm();
  }
  const showModal = (e) => {
    e.preventDefault()
    setShow(true);
  }

  useEffect(() => {
    if (shouldOpen) {
      showModal(true)
    }
  }, [shouldOpen])

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: gqlCall,
      query_key: 'updatePlateIngredient',
      success: (res) => {
        closeModal()
      },
      flash_callback: setFlash
    })
  }

  return (
    <>
      {showButton && <EditButton to='#' onClick={showModal}/>}

      <Modal show={show} onHide={closeModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Mofdifica ingredientul</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row justify-content-md-center">
              <PlateIngredientForm
                onSubmit={onSubmit} flash={flash}
                plateIngredient={plateIngredient}
                plateIngredientIds={plateIngredientIds}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
};

export default EditPlateIngredientModal;